/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { FormLabel } from 'carbon-addons-iot-react';
import React from 'react';
import PropTypes from 'prop-types';

import styles from './ReadOnlyField.module.css';

const propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};

/** Consistent way to render a readonly field */
const ReadOnlyField = ({ label, value }) => (
  <>
    <FormLabel>{label}</FormLabel>
    <div className={styles.readOnlyValue}>{value}</div>
  </>
);

ReadOnlyField.propTypes = propTypes;
export default ReadOnlyField;
